<script>
	import { Link } from 'svelte-routing';
	import {getLinkProps, jumpToAnchor} from '../share/utils';
	import { onMount } from 'svelte';
	import { cookiesActivated } from '../share/stores';

	export let html = '';
	export let noOuterDiv = false;
	export let attributes;
	export let url;
	export let text;

	export let extraClass;

	export let callBack = false;

	onMount(() => {
		if (url && text) {
			return;
		}
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;
		url = tempDiv.querySelector('*') ? tempDiv.querySelector('*').getAttribute('url') : url;
		text = tempDiv.querySelector('*') ? tempDiv.querySelector('*').getAttribute('text') : text;
		if (attributes) {
			noOuterDiv = attributes?.noOuterDiv?.value === "true";
			extraClass = attributes?.extraClass?.value;
		}
	});

	let link;

	onMount(() => {
		if(link.querySelector('.del_cookies')) {
			extraClass = 'del_cookies';
			text = 'Cookies löschen';
			callBack = () => {
				localStorage.removeItem('b1-cookies');
				cookiesActivated.set(false);
			}
		}
	})
</script>

{#if noOuterDiv && !callBack}
	<Link aria-label="{text || `link to ${url}`}" getProps={getLinkProps} to={url}
		  on:click={() => url && url.split('#')[1] ? jumpToAnchor(url.split('#')[1] || false) : false}>
		{#if text}
			{@html text}
		{:else}
			<slot/>
		{/if}
	</Link>
{:else}
	<div class="{extraClass}" bind:this={link}>
		{#if callBack}
			<button aria-label="{text || `link to ${url}`}" on:click={() => {url && url.split('#')[1] ? jumpToAnchor(url.split('#')[1] || false) : false; callBack()}}>
				<Link getProps={getLinkProps} to={url}>
					{#if text}
						{@html text}
					{:else}
						<slot/>
					{/if}
				</Link>
			</button>
		{:else}
			<Link aria-label="{text || `link to ${url}`}" getProps={getLinkProps} to={url}
				  on:click={() => url && url.split('#')[1] ? jumpToAnchor(url.split('#')[1] || false) : false}>
				{#if text}
					{@html text}
				{:else}
					<slot/>
				{/if}
			</Link>
		{/if}
	</div>
{/if}

<style lang="scss">
	@import "../style/variables";
	@import "../style/mixins";

	div {
		position: relative;
		z-index: 5;

		button {
			background: none;
			color: inherit;
			border: none;
			padding: 0;
			font: inherit;
			cursor: pointer;
			outline: inherit;

			:global(a) {
				pointer-events: none;
			}
		}

		&.close.right :global(> button a) {
			width: 1.65rem;
			aspect-ratio: 1;
			border: solid #dedede;
			border-width: 0 5px 5px 0;
			padding: 10px;
			position: relative;
			display: block;
			transform: rotate(135deg);
		}

		&.icon_plus :global(a::before) {
			content: "+";
			background: black;
			color: white;
			width: 1.3em;
			height: 1.3em;
			text-align: center;
			border-radius: 50%;
			line-height: 1.3em;
		}

		&.icon_left :global(a) {
			margin-left: 4.4em;
		}

		&.icon_left :global(a::before) {
			position: absolute;
			left: 0;
		}

		&:global(.in_accordion) {
			width: max-content;
			display: block;
			text-align: center;
			text-transform: uppercase;
			border-radius: var(--border-burgeins);
			text-decoration: none;
			background-color: var(--color-burgeins-6);
			color: #ffffff;
			padding: 0.5em 2em;
		}

		&:global(.del_cookies button) {
			width: 100%;
			margin: 0;
			line-height: 0;
		}
	}
</style>

